/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconLocationPinFill(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 16 16"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.4 6.4C14.4 11.2 8 16 8 16s-6.4-4.8-6.4-9.6a6.4 6.4 0 0 1 12.8 0"
      />
    </svg>
  );
}
